import React, { useState } from 'react';
import CompanySelect from './CompanySelect';
import ReferralForm from './ReferralForm';
import ReferralConfirmation from './ReferralConfirmation';
import './ReferralFlow.css';

function ReferralFlow() {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    company: null,
    name: '',
    email: '',
    phone: '',
    resume: null,
    message: ''
  });

  const handleCompanySelect = (company) => {
    setFormData({ ...formData, company });
    setStep(2);
  };

  const handleFormSubmit = (data) => {
    setFormData({ ...formData, ...data });
    setStep(3);
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return <CompanySelect onSelect={handleCompanySelect} />;
      case 2:
        return <ReferralForm onSubmit={handleFormSubmit} company={formData.company} />;
      case 3:
        return <ReferralConfirmation data={formData} />;
      default:
        return null;
    }
  };

  return (
    <div className="referral-flow">
      <div className="progress-bar">
        <div className={`progress-step ${step >= 1 ? 'active' : ''}`}>
          <div className="step-number">1</div>
          <span>Select Company</span>
        </div>
        <div className={`progress-connector ${step >= 2 ? 'active' : ''}`}></div>
        <div className={`progress-step ${step >= 2 ? 'active' : ''}`}>
          <div className="step-number">2</div>
          <span>Enter Details</span>
        </div>
        <div className={`progress-connector ${step >= 3 ? 'active' : ''}`}></div>
        <div className={`progress-step ${step >= 3 ? 'active' : ''}`}>
          <div className="step-number">3</div>
          <span>Confirmation</span>
        </div>
      </div>
      {renderStep()}
    </div>
  );
}

export default ReferralFlow; 